import { CategoryColorSpec } from './types';

const PALETTE: CategoryColorSpec[] = [
  { color: '#1373C0', bg: '#E9F2FF', border: '#A9C6F2' },
  { color: '#0D6B4D', bg: '#EEF9F5', border: '#A7DBC8' },
  { color: '#B84A00', bg: '#FFF5EE', border: '#F3C39B' },
  { color: '#A01B2D', bg: '#FDF0F2', border: '#EBB3BB' },
  { color: '#7B2D8B', bg: '#F5EEF9', border: '#D4A9E1' },
  { color: '#58595A', bg: '#F1F2F3', border: '#D8D9DA' },
];

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

// MessageBubble calls these per message; cache by category name since the set
// of distinct names is small and stable for a session.
const colorCache = new Map<string, CategoryColorSpec>();
const displayNameCache = new Map<string, string>();

export function getCategoryColor(nameOrId: string): CategoryColorSpec {
  const cached = colorCache.get(nameOrId);
  if (cached) return cached;
  const spec = PALETTE[hashString(nameOrId) % PALETTE.length];
  colorCache.set(nameOrId, spec);
  return spec;
}

export function stripCategoryPrefix(name: string): string {
  // Strips leading uppercase prefix like "SS_", "CC_", etc.
  return name.replace(/^[A-Z]{2,}_/, '');
}

export function getCategoryDisplayName(name: string): string {
  const cached = displayNameCache.get(name);
  if (cached !== undefined) return cached;
  const display = stripCategoryPrefix(name);
  displayNameCache.set(name, display);
  return display;
}
